import { Component, Input } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-fields/abstract-value-accessor/abstract-value';
import { makeProvider } from '@shared/form-fields/make-provider';
import type { DateTime } from 'luxon';

@Component({
    selector: 'app-input-timestamp',
    styleUrls: ['./timestamp-input.component.scss'],
    template: `
        <div
            *ngIf="label"
            class="text-title-small">
            {{ label }}
        </div>

        <div class="input-timestamp-row">
            <app-input-date
                style="min-width: 128px; width: 100%;"
                label="Date"
                name="start_date"
                data-testid="input:date"
                valueType="datetime"
                [(ngModel)]="value"
                [minDate]="minDate"
                [maxDate]="maxDate"
                (ngModelChange)="onStartChange()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="disabled"
                [required]="required"
                [clearable]="clearable"
            />

            <app-input-time
                style="min-width: 128px; width: 100%;"
                label="Time"
                name="start_time"
                valueType="datetime"
                [(ngModel)]="value"
                (ngModelChange)="onStartChange()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="disabled"
                [required]="required"
                [clearable]="clearable"/>

            <ng-content></ng-content>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
        `,
    ],
    providers: [makeProvider(TimestampInputComponent)],
})
export class TimestampInputComponent extends AbstractInputComponent<string | DateTime> {
    @Input() clearable = false;
    @Input() minDate = null;
    @Input() maxDate = null;
    @Input() label?: string;

    onStartChange() {
        this.dispatchChange();
    }
}
